import { useRouterState } from "@tanstack/react-router";
import { t } from "../i18n.ts";
import { findSection } from "./sections.ts";

/** Название текущего экрана для шапки телефона и вкладки браузера. */
export function usePageTitle(): string {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const [, first, second] = pathname.split("/");
  if (first === "s" && second) {
    const section = findSection(second);
    if (section) return t(section.label);
  }
  if (first === "stock") {
    const third = pathname.split("/")[3];
    if (second === "shelf") return t("shelf.title");
    if (second === "product") return t("product.title");
    if (second === "today") return t("today.title");
    if (second === "issue") return t("today.tab.issue");
    if (second === "requests") return third === "new" ? t("draft.title") : t("requests.title");
    return t("section.stock");
  }
  if (first === "purchasing") return second === "orders" ? t("order.title") : t("purchasing.title");
  if (first === "production") {
    const third = pathname.split("/")[3];
    if (second === "orders") return third === undefined ? t("mo.list.title") : third === "new" ? t("mo.new") : t("mo.title");
    if (second === "boms") return t("bom.list.title");
    if (second === "my") return t("my.title");
    if (second === "unit") return t("unit.title");
    return t("line.title");
  }
  if (first === "catalog") return t("catalog.title");
  if (first === "partners") return t("partners.title");
  if (first === "attendance") return t("section.attendance");
  if (first === "hr") {
    if (second === "employees") return t("people.employees");
    if (second === "leave") return t("leave.title");
    if (second === "expenses") return t("exp.title");
    if (second === "doors") return t("doors.title");
    if (second === "terminals") return t("term.title");
    return t("section.hr");
  }
  if (first === "sales") return t("sales.title");
  if (first === "service") return t("repair.title");
  if (first === "costing") {
    if (second === "pnl") return t("costing.pnl.title");
    if (second === "prices") return t("costing.prices.title");
    return t("costing.close.title");
  }
  if (first === "money") return second === "opex" ? t("opex.title") : t("bank.title");
  if (first === "scan") return t("scan.label");
  if (first === "ui") return t("ui.title");
  return t("section.desk");
}
